<template>
  <div class="sidebar-layout">
    <!-- Conteúdo da barra lateral -->
    <Sidebar>
      <template #sidebar-content>
        <slot name="sidebar" />
      </template>
    </Sidebar>

    <div class="content">
      <Breadcrumb :path="breadcrumb" :rootPath="rootPath" />

      <!-- Espaço para inserir o menu de hotéis ou algum conteúdo relevante
      quando necessário -->
      <slot name="gap-before-content" />

      <!-- Conteúdo principal -->
      <div class="content--white_card">
        <div
          v-if="pageTitle"
          class="page-heading"
          :class="{ 'has-page-description': this.$slots['page-description'] }"
        >
          <h2 class="page-heading--title">
            {{ pageTitle }}
          </h2>

          <div
            class="page-heading--description"
            v-if="this.$slots['page-description']"
          >
            <slot name="page-description" />
          </div>
        </div>

        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Layout com o modelo para listagens
 * @see https://www.figma.com/file/JvXkgtkQi2HYE6Gn0sqvlz26/Hotels-Design-System?node-id=2841%3A609
 * Ex: Tela de listagem de cupons
 */
import Breadcrumb from '@/components/_base/patterns/Breadcrumb'
import Sidebar from '@/components/_base/patterns/Sidebar'

export default {
  name: 'SidebarLayout2',
  components: {
    Breadcrumb,
    Sidebar
  },
  props: {
    /**
     * Caminho de pão
     */
    breadcrumb: {
      type: Array,
      default: () => [
        {
          label: 'Link 1',
          url: '/',
          isSpa: false /** se é um link para o site novo ou antigo */
        },
        {
          label: 'Link 2',
          url: '/',
          isSpa: true /** se é um link para o site novo ou antigo */
        }
      ]
    },
    /**
     * Link inicial do caminho de pão
     */
    rootPath: {
      type: Object,
      default: () => ({
        label: 'Home',
        url: '/',
        isSpa: true /** se é um link para o site novo ou antigo */
      })
    },
    pageTitle: {
      type: String,
      default: ''
    }
  },
  created() {
    /** Retorna URL salva no LocalStorage */
    const savedURL = localStorage.getItem('homePage')

    /** Define o URL como a página principal do usuário */
    if (savedURL !== null) {
      this.rootPath.url = savedURL
      this.rootPath.isSpa = false
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar-layout {
  display: grid;
  grid-template-columns: 250px 1fr;
  grid-gap: 0 26px;
  min-height: calc(100vh - 50px);
  background-color: $gray-bg;

  & > .content {
    width: calc(100% - 26px);
    padding-top: 34px;
  }
}

.content {
  text-align: left;
  margin-bottom: 40px;

  &--white_card {
    margin-top: 18px;
    background-color: $white;
    padding: {
      top: card-spacing('side-large');
      right: card-spacing('side-large');
      left: card-spacing('side-large');
      bottom: card-spacing('bottom-large');
    }
    @include drop-shadow();

    /**
    * Espacamento padrao para titulo e descricao
    * Ref: https://www.figma.com/file/9AFe6i7bVhMup1bYeppCU7/Tarifas?node-id=19%3A3557
    */
    .page-heading {
      padding-bottom: card-spacing('bottom-medium');
      /**
      * Quando houver descrição: mantém o espacamento padrão reduzindo a altura ocupada pela descrição
      * Cálculo: Espaçamento padrão - (Font-size + margin)
      */
      &.has-page-description {
        padding-bottom: calc(
          #{card-spacing('bottom-medium')} - (#{font-size('size-small')} + 5px)
        );
      }

      &--title {
        letter-spacing: -1px;
        font-weight: 500;
        font-size: font-size('size-xx-large');
        color: $gray-darkest;
      }

      &--description {
        font-size: font-size('size-small');
        font-weight: font-size('weight-normal');
        margin-top: 5px;
      }
    }
  }
}
</style>
